import React from 'react';
import CohortQueryMenuItem from './CohortQueryMenuItem';

const CohortQueryMenuItems = ({
  code,
  category,
  queries,
  queryUUID,
  canEdit,
  validationErrors,
  saveErrors,
  updatePanels,
}) => (
  queries.map((query) => (
    <CohortQueryMenuItem
      key={`cohort_query_menu_${query.uuid}`}
      name={query.name}
      uuid={query.uuid}
      status={query.status}
      code={code}
      category={category}
      active={queryUUID === query.uuid}
      canEdit={canEdit}
      validationErrors={validationErrors}
      saveErrors={saveErrors}
      updatePanels={updatePanels}
    />
  ))
);

export default CohortQueryMenuItems;
